import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT } from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";
import { DateUtil } from '../../../util/DateUtil';
import { DATE_FORMAT, MIME_TYPE } from '../../../constants/constants';
import { DocumentPreview } from '../../viewDocument/DocumentPreview';
import { LoadingUtil } from '../../../util/LoadingUtil';
import { EnvConstants } from '../../../EnvConstants';
import { DonwloadUtil } from '../../../util/DonwloadUtil';

export class SolicitudesEjecutadasAdminPage extends BasePage {

  createPageProperties = (pageApi) => {
    return {
      title: 'SOLICITUDES EJECUTADAS'
    };
  }

  renderPage(pageApi) {
    const getGridSoli_asignadas = () => pageApi.getComponent('grid');
    const getFormSoli_asignadas = () => pageApi.getComponent('form');

    const DocumentPreviewModal = (data) => {
      return {
        width: 950,
        maskClosable: true,
        closable: false,
        component: <DocumentPreview name={data} getParentApi={pageApi.getApi} />
      }
    };

    const formSoli_asignadasConfig = {
      layout: 'vertical',
      fields: [
        {name: 'nro_ss', label: 'Nro. Solicitud:', column: 2 },
        {type: 'select', name:'estado', label:'Estado', column: 4,  
          load: {
            dataList: [
              {label: 'Todos', value: 0},
              {label: 'Pendiente Aprobacion', value: 1},
              {label: 'Cerrado', value: 2},  
            ]
          }
        },  
        { type: 'date', name: 'fecha_desde', label: 'Desde', column: 2, value: DateUtil.getDate2(15), format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD },
        { type: 'date', name: 'fecha_hasta', label: 'Hasta', column: 2, value: DateUtil.getDate, format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD },
      ]
    };

    const gridSoli_ejecutadasConfig = {
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      load: {
        queryId: 898,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: 'servicio', label: 'Tipo Servicio' },
        { name: 'doc_nro_ss', label: 'Nro Solicitud' },
        { name: 'empresa', label: 'Cliente' }, 
        { name: 'fecha_servicio', label: 'Fecha Inicio Servicio' },
        { name: 'fecha_final', label: 'Fecha Fin Servicio' },
        { name: 'estado', label: 'estado' },
        {
          ...COLUMN_DEFAULT.OPTIONS, label: 'Opciones', colSpan: 6, title: 'Configurar Cadena', color: 'blue',
          link: (value, row, index) => `/solicitudes-ejecutadas/solicitudes-ejecutadas/${row.id_doc}`,
          // fnVisible: (value, row, index) => {
          //     return RetornaVisulizacionBoton(row?.estado, 'editar')
          // }, 
        },
      ]
    };

    const barButtonSoli_asignadasconfig = {
      fields: [
        { ...BUTTON_DEFAULT.SEARCH, onClick: () => getGridSoli_asignadas().load({ params: getFormSoli_asignadas().getData() }) },
        { ...BUTTON_DEFAULT.CLEAR1, onClick: () => getFormSoli_asignadas().setData({
          fecha_desde: DateUtil.getDate2(15),
          fecha_hasta: DateUtil.getDate,
          estado: null,
          nro_ss: null
        }) },
      ]
    }

    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formSoli_asignadasConfig}
        />
        <BarButtonFw
          name="bar"
          getParentApi={pageApi.getApi}
          config={barButtonSoli_asignadasconfig}
        />
        <GridFw
          name="grid"
          getParentApi={pageApi.getApi}
          config={gridSoli_ejecutadasConfig}
        />
      </>
    )
  }
}
